import { observable, computed } from 'mobx';

export default class TimelineEventInstanceModel {
    @observable timelineEventInstanceId;
    @observable timelineEventId;
    @observable state;
    @observable order;
    @observable name;
    @observable days;
    @observable exclude;
    @observable excludeFromWorkflow;
    @observable excludeFromEmailGrid;
    @observable excludeFromCalendarReminders;
    @observable weekendsCount;
    @observable holidaysCount;
    @observable canLandOnWeekend;
    @observable canLandOnHoliday;
    @observable custom;
    @observable eventType;
    @observable recurrences;
    holidayDateShift;
    weekendDateShift;
    deadlineCalculated;
    reminders;

    constructor() {}
}



// WEBPACK FOOTER //
// ./src/workflow/steps/timeline/timeline-event-instance-model.js